module.exports = __webpack_public_path__ + "img/partner_img14.936eee87.png";